/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./select-popup.vue.js?vue&type=template&id=c8789d98&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./select-popup.vue?vue&type=template&id=c8789d98&scoped=true"
import script from "./select-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./select-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./select-popup.vue.js?vue&type=script&setup=true&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./select-popup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./select-popup.vue.postcss?vue&type=style&index=0&id=c8789d98&prod&lang=postcss&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./select-popup.vue?vue&type=style&index=0&id=c8789d98&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8789d98",
  null
  
)

export default component.exports